import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import French translations
import frCommon from '../locales/fr/common';
import frArchitecture from '../locales/fr/architecture';
import frFinops from '../locales/fr/finops';
import frErrors from '../locales/fr/errors';
import frNavigation from '../locales/fr/navigation';
import frProjects from '../locales/fr/projects';
import frDashboard from '../locales/fr/dashboard';
import frTemplates from '../locales/fr/templates';
import frCloudServices from '../locales/fr/cloudServices';
import frHome from '../locales/fr/home';
import frGettingStarted from '../locales/fr/gettingStarted';
import frSettings from '../locales/fr/settings';
import frAuth from '../locales/fr/auth';
import frCanvas from '../locales/fr/canvas';
import frMonitoring from '../locales/fr/monitoring';

// Import English translations
import enCommon from '../locales/en/common';
import enArchitecture from '../locales/en/architecture';
import enFinops from '../locales/en/finops';
import enErrors from '../locales/en/errors';
import enNavigation from '../locales/en/navigation';
import enProjects from '../locales/en/projects';
import enDashboard from '../locales/en/dashboard';
import enTemplates from '../locales/en/templates';
import enCloudServices from '../locales/en/cloudServices';
import enHome from '../locales/en/home';
import enGettingStarted from '../locales/en/gettingStarted';
import enSettings from '../locales/en/settings';
import enAuth from '../locales/en/auth';
import enCanvas from '../locales/en/canvas';
import enMonitoring from '../locales/en/monitoring';

// Initialiser i18next avec toutes les ressources directement
i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    lng: localStorage.getItem('language') || 'fr',
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'common',
    ns: ['common', 'architecture', 'finops', 'errors', 'navigation', 'projects', 'dashboard', 'templates', 'cloudServices', 'home', 'gettingStarted', 'settings', 'auth', 'canvas', 'monitoring'],

    resources: {
      fr: {
        common: frCommon,
        architecture: frArchitecture,
        finops: frFinops,
        errors: frErrors,
        navigation: frNavigation,
        projects: frProjects,
        dashboard: frDashboard,
        templates: frTemplates,
        cloudServices: frCloudServices,
        home: frHome,
        gettingStarted: frGettingStarted,
        settings: frSettings,
        auth: frAuth,
        canvas: frCanvas,
        monitoring: frMonitoring,
      },
      en: {
        common: enCommon,
        architecture: enArchitecture,
        finops: enFinops,
        errors: enErrors,
        navigation: enNavigation,
        projects: enProjects,
        dashboard: enDashboard,
        templates: enTemplates,
        cloudServices: enCloudServices,
        home: enHome,
        gettingStarted: enGettingStarted,
        settings: enSettings,
        auth: enAuth,
        canvas: enCanvas,
        monitoring: enMonitoring,
      },
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },
  });

// Sauvegarder la langue dans localStorage quand elle change
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
